import { NetworkQualityLevel as NetworkQualityLevelType } from "twilio-video";
import { BiWifi, BiWifi1, BiWifi2, BiWifi0, BiWifiOff } from "react-icons/bi";
import styled from "styled-components";
import { useLocalParticipant } from "../../hooks/useLocalParticipant";
import { useRemoteParticipant } from "../../hooks/useRemoteParticipant";

const NetworkQualityWrapper = styled("div")`
  z-index: 5;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface INetworkQualityLevelProps {
  participant: "local" | "remote";
}

const NetworkQualityLevel = ({ participant }: INetworkQualityLevelProps) => {
  const { networkQualityLevelLocal } = useLocalParticipant();
  const { networkQualityLevelRemote } = useRemoteParticipant();

  const iconSize = 28;

  /**
   * @param qualityLevel número de 0-5 indicando qual a qualidade da conexão do usuário
   * @returns ícone indicando qualidade da conexão
   */
  const handleNetWorkQualityLevel = (
    qualityLevel: NetworkQualityLevelType
  ): JSX.Element => {
    switch (qualityLevel) {
      case 0:
        return <BiWifiOff size={iconSize} fill="red" />;
      case 1:
        return <BiWifi0 size={iconSize} fill="red" />;
      case 2:
        return <BiWifi0 size={iconSize} fill="yellow" />;
      case 3:
        return <BiWifi1 size={iconSize} fill="yellow" />;
      case 4:
        return <BiWifi2 size={iconSize} fill="#2adc19" />;
      case 5:
        return <BiWifi size={iconSize} fill="#2adc19" />;
      default:
        return <></>;
    }
  };

  return (
    <NetworkQualityWrapper>
      {handleNetWorkQualityLevel(
        participant === "local"
          ? networkQualityLevelLocal
          : networkQualityLevelRemote
      )}
    </NetworkQualityWrapper>
  );
};

export default NetworkQualityLevel;
